export default "__VITE_ASSET__3ce51c06__"